import { motion } from 'framer-motion';
import {
  BeakerIcon,
  MegaphoneIcon,
  ShieldCheckIcon,
  DocumentTextIcon,
  UserGroupIcon,
  CommandLineIcon,
  CpuChipIcon,
  CubeTransparentIcon,
} from '@heroicons/react/24/outline';

const Ecosystem = () => {
  const ecosystemAreas = [
    {
      title: "Beta Testing",
      description: "End to End Testing for Blockchain and ZK projects",
      icon: BeakerIcon,
      code: "TEST_001"
    },
    {
      title: "Marketing Support",
      description: (
        <>
          Run your AI consumer engagement with{' '}
          <a
            href="https://gatta.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-400 hover:text-indigo-300 underline"
          >
            Gatta.io
          </a>
        </>
      ),
      icon: MegaphoneIcon,
      code: "MKT_002"
    },
    {
      title: "Pre-Audits",
      description: "Save costs by thorough security assessment and design tests before your external audits",
      icon: ShieldCheckIcon,
      code: "SEC_003"
    },
    {
      title: "Research & Content",
      description: "In-depth research and educational content creation for ZK technology",
      icon: DocumentTextIcon,
      code: "RES_004"
    }
  ];

  const workingApproach = [
    {
      title: "Flexible Approach",
      description: "Not sure how to go about it? Let us build a POC that can be extended to a MVP.",
      icon: CpuChipIcon,
      code: "FLX_001"
    },
    {
      title: "Low Cost",
      description: "We want to keep the cost low which is why we tap into our global developer community.",
      icon: CubeTransparentIcon,
      code: "CST_002"
    }
  ];

  const socialLinks = [
    {
      name: "Telegram",
      url: "https://t.me/+D1eJ7No8srI3YTQx",
      code: "TG_001",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18.717-.962 3.767-1.362 5.592-.168.771-.319 1.433-.462 2.025-.144.592-.27 1.095-.377 1.51-.108.414-.203.75-.284 1.005-.082.256-.152.451-.211.586-.059.135-.109.223-.15.264-.04.041-.072.062-.094.062-.108 0-.23-.052-.367-.157-.138-.104-.282-.241-.432-.41-.15-.17-.41-.421-.779-.755-.37-.334-.77-.68-1.2-1.037-.517-.43-.97-.792-1.36-1.085-.39-.293-.718-.507-.983-.642-.265-.135-.48-.203-.644-.203-.12 0-.23.047-.332.14-.101.094-.152.214-.152.361 0 .148.05.311.152.49.101.179.242.368.422.567.18.2.435.452.767.76.332.307.66.604.983.89.323.287.614.543.873.77.258.226.451.397.578.513.127.115.19.179.19.19 0 .012-.006.018-.019.018-.063 0-.152-.044-.266-.13-.114-.087-.262-.214-.445-.383-.183-.17-.414-.387-.692-.652-.279-.265-.575-.547-.89-.847-.315-.3-.614-.584-.898-.852-.284-.269-.536-.5-.755-.693-.22-.194-.394-.338-.524-.432-.13-.095-.217-.142-.26-.142-.032 0-.06.015-.085.047-.025.032-.038.073-.038.124 0 .05.013.111.038.18.025.07.082.176.17.32.088.143.216.338.386.584.17.246.337.483.503.71.165.226.33.449.495.67.165.22.305.407.42.56.114.152.208.276.284.371.076.095.114.142.114.142 0 .012-.013.018-.038.018-.063 0-.158-.047-.284-.142-.127-.095-.289-.237-.487-.427-.198-.19-.433-.425-.704-.705-.272-.28-.55-.567-.835-.861-.284-.295-.557-.576-.816-.843-.26-.269-.49-.504-.692-.705-.203-.2-.363-.356-.48-.465-.12-.11-.19-.164-.21-.164-.032 0-.05.023-.057.07-.006.047-.01.117-.01.21v.28c0 .111.003.238.01.38.006.143.01.282.01.418 0 .136-.004.258-.01.366-.006.109-.01.164-.01.164 0 .037-.013.056-.038.056-.044 0-.12-.044-.228-.133-.107-.088-.239-.214-.394-.376-.155-.161-.337-.356-.546-.584-.21-.227-.433-.478-.67-.751-.239-.273-.47-.546-.693-.817-.223-.272-.426-.523-.61-.753-.183-.23-.335-.421-.455-.574-.12-.152-.19-.24-.21-.264-.019-.025-.038-.037-.057-.037-.025 0-.038.019-.038.056 0 .037.025.111.076.223.05.111.12.245.207.399.088.155.19.33.304.528.114.199.233.4.357.603.123.204.246.4.37.59.122.19.236.363.34.52.102.158.19.288.265.39.074.102.114.155.12.158.007.004.01.01.01.018 0 .012-.006.018-.019.018-.063 0-.158-.052-.284-.157-.127-.104-.286-.249-.48-.433-.193-.183-.414-.4-.663-.65-.248-.25-.505-.509-.77-.776-.265-.267-.523-.527-.774-.78-.252-.254-.473-.477-.663-.67-.19-.194-.338-.344-.445-.452-.108-.109-.17-.163-.19-.163-.025 0-.044.021-.057.065-.012.043-.019.112-.019.207v.304c0 .13.003.276.01.437.006.162.01.318.01.47 0 .152-.004.289-.01.41-.006.12-.01.182-.01.182 0 .037-.013.056-.038.056-.044 0-.111-.039-.2-.118-.088-.078-.193-.188-.313-.327-.12-.14-.255-.304-.404-.494-.15-.19-.307-.392-.47-.607-.164-.214-.33-.43-.497-.647-.168-.217-.33-.425-.487-.622-.158-.198-.301-.374-.432-.528-.13-.155-.236-.278-.318-.371-.082-.094-.133-.14-.152-.14-.025 0-.038.018-.038.055 0 .037.019.102.057.194.038.093.095.208.17.347.076.14.17.304.285.494.114.19.239.392.375.607.136.214.273.425.413.633.14.207.273.4.4.578.127.179.24.33.337.456.098.127.158.2.18.223.025.025.038.046.038.065 0 .012-.006.018-.019.018z" />
        </svg>
      ),
    },
    {
      name: "Discord",
      url: "https://discord.com/invite/ccFPTKjUwt",
      code: "DC_002",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
        </svg>
      ),
    },
    {
      name: "X (Twitter)",
      url: "https://x.com/Modulo_Labs",
      code: "TW_003",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      ),
    }
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      {/* Hero Section */}
      <header className="relative overflow-hidden pt-32 pb-24">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(99,102,241,0.05),transparent_50%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(99,102,241,0.02)_1px,transparent_1px),linear-gradient(to_bottom,rgba(99,102,241,0.02)_1px,transparent_1px)] bg-[size:14px_24px]" />
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"
        >
          {/* Header decoration */}
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
            [SYSTEM::ECOSYSTEM_ACCESS]
          </div>

          <div className="mb-8">
            <CommandLineIcon className="w-16 h-16 text-indigo-400 mx-auto mb-6" />
            <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto font-mono">
              The future of innovation is the open source ecosystem. We are building this coordination mechanism of shared incentive by uniting humans and machine intelligence.
            </p>
          </div>
        </motion.div>
      </header>

      {/* Ecosystem Support Areas */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(99,102,241,0.05),transparent_50%)]" />
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
            [ECOSYSTEM::SUPPORT_SERVICES]
          </div>

          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold mb-6 font-mono">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-400 to-indigo-500">
                How We Support the Ecosystem
              </span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {ecosystemAreas.map((area, index) => (
              <motion.div
                key={area.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.02 }}
                className="relative group"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/30 to-purple-900/30 rounded-lg backdrop-blur-sm border border-indigo-500/20 
                  group-hover:border-indigo-500/40 transition-all duration-300" />
                
                <div className="relative p-8">
                  <div className="flex items-center justify-between mb-6">
                    <area.icon className="w-8 h-8 text-indigo-400" />
                    <div className="font-mono text-xs text-indigo-500/60">{area.code}</div>
                  </div>
                  
                  <h3 className="text-xl font-bold text-white mb-3 font-mono">{area.title}</h3>
                  <p className="text-slate-400 font-mono">{area.description}</p>

                  {/* Corner decorations */}
                  <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-indigo-500/20 rounded-tr-lg" />
                  <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-indigo-500/20 rounded-bl-lg" />
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>

      {/* Working Approach */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(99,102,241,0.05),transparent_50%)]" />
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
            [SYSTEM::METHODOLOGY]
          </div>

          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold mb-6 font-mono">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-400 to-indigo-500">
                How We Work
              </span>
            </h2>
            <p className="text-lg text-slate-400 max-w-2xl mx-auto font-mono">
              We want to be your partner in success... be part of your roadmap to achieve a common purpose
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {workingApproach.map((approach, index) => (
              <motion.div
                key={approach.title}
                initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                whileHover={{ scale: 1.02 }}
                className="relative group"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/30 to-purple-900/30 rounded-lg backdrop-blur-sm border border-indigo-500/20 
                  group-hover:border-indigo-500/40 transition-all duration-300" />
                
                <div className="relative p-8">
                  <div className="flex items-center justify-between mb-6">
                    <approach.icon className="w-8 h-8 text-indigo-400" />
                    <div className="font-mono text-xs text-indigo-500/60">{approach.code}</div>
                  </div>
                  
                  <h3 className="text-xl font-bold text-white mb-3 font-mono">{approach.title}</h3>
                  <p className="text-slate-400 font-mono">{approach.description}</p>

                  {/* Corner decorations */}
                  <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-indigo-500/20 rounded-tr-lg" />
                  <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-indigo-500/20 rounded-bl-lg" />
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>

      {/* Join Community Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(99,102,241,0.05),transparent_50%)]" />
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
            [COMMUNITY::JOIN_NETWORK]
          </div>

          <div className="text-center mb-16">
            <UserGroupIcon className="w-12 h-12 text-indigo-400 mx-auto mb-6" />
            <h2 className="text-3xl font-bold mb-6 font-mono">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-400 to-indigo-500">
                Want to contribute and be part of the community?
              </span>
            </h2>
            <p className="text-lg text-slate-400 max-w-2xl mx-auto font-mono mb-12">
              Join now and connect with us on our social channels
            </p>

            <div className="flex flex-wrap justify-center gap-6">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  whileHover={{ scale: 1.05 }}
                  className="relative group"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-slate-800/50 to-slate-900/50 rounded-lg backdrop-blur-sm border border-indigo-500/20 
                    group-hover:border-indigo-500/40 transition-all duration-300" />
                  
                  <div className="relative flex items-center gap-3 px-6 py-3">
                    <span className="text-indigo-400 group-hover:text-indigo-300 transition-colors">
                      {social.icon}
                    </span>
                    <span className="text-white font-medium font-mono">{social.name}</span>
                    <span className="font-mono text-xs text-indigo-500/60">{social.code}</span>
                  </div>
                </motion.a>
              ))}
            </div>
          </div>

          {/* Footer decoration */}
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
            [END::JOIN_NETWORK]
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default Ecosystem;